/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Contains the names of the Sentry tags that identify the tenant behind an event. Backend and
 * frontend report into separate Sentry projects, so a query can only correlate the two if both
 * sides use the same tag names.
 */
export class SentryTags {
    /**
     * The id of the client the session belongs to
     */
    static readonly client_id: string = 'client_id';
    /**
     * The id of the mandant the session acts for
     */
    static readonly mandant_id: string = 'mandant_id';
    /**
     * The id of the partnership the session was opened under
     */
    static readonly partnership_id: string = 'partnership_id';
}
